import React from 'react'
import { Row, Col } from 'antd'
import { BlendForms } from './Form/BlendForms'
import { Horizontal, NothingMessage, Texto } from '@gravitate-js/excalibrr'

export const BlendRows = ({ editable, setEditMode, products, selectedProduct, updateRow }) => {
  if (!selectedProduct.blends || selectedProduct.blends?.length === 0) {
    return (
      <Horizontal flex={1} horizontalCenter verticalCenter>
        <NothingMessage className='mt-2' message='No product blends have been created.' />
      </Horizontal>
    )
  }

  if (selectedProduct.blends.length > 0)
    return (
      <>
        <Row style={{ background: 'var(--bg-1)' }}>
          <Col span={12}>
            <BlendHeaderRow />
          </Col>
          <Col span={12}>
            <BlendHeaderRow />
          </Col>
        </Row>

        <div className='blend-rows-container bg-1'>
          <BlendForms
            editable={editable}
            setEditMode={setEditMode}
            products={products}
            selectedProduct={selectedProduct}
            updateRow={updateRow}
          />
        </div>
      </>
    )
}

const BlendHeaderRow = () => {
  return (
    <Horizontal bg='elevated' verticalCenter className='pr-2' border='right'>
      <Texto appearance='hint' style={{ flex: 12 }} className='data-label control blend-component-percent-col'>
        Blend Control
      </Texto>
      <Texto appearance='hint' style={{ flex: 6 }} className='data-label blend-component-percent-col'>
        Component
      </Texto>

      <Texto appearance='hint' style={{ flex: 6 }} align='right'>
        Percentage
      </Texto>
    </Horizontal>
  )
}
